// Stripe Live Publishable Key
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51P2Dn709Z71ldPawE5bS9PjLtpPU01TYccqVwByJFoSLKF49OziWlAw9ffLB6Xw7T5w047yJ1tAUCcqAl0KhIZWm00kqqBFczE';

// Stripe will be initialized in the Checkout component
